import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PrFormInputDateComponent),
  multi: true,
};

@Component({
    selector: 'pr-form-input-date',
    templateUrl: './pr-form-input-date.component.html',
    styleUrls: ['./pr-form-input-date.component.scss'],
    standalone: false
})
export class PrFormInputDateComponent implements OnInit, AfterViewInit {
  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  @Input() value = '';
  @Input() control: UntypedFormControl;
  _value = '';

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => (this._value = this.value), 0);
  }

  updateChanges($event) {
    this.value = $event.value;
    this.update.emit();
  }
}
